import {
  Typography,
  Loading,
} from "../../../components/common";
import CommonAuthLayout from "../CommonAuthLayout";
import { useSetPasswordHook } from "./useSetPasswordHook";

const APP_LOGIN_URL = process.env.REACT_APP_APP_HOME_URL
  ? `${process.env.REACT_APP_APP_HOME_URL}/login`
  : "https://app.pedagogue.io/login";

export const SetPassword = () => {
  useSetPasswordHook();

  return (
    <CommonAuthLayout
      isLogin={false}
      onNavigate={() => {
        window.location.href = APP_LOGIN_URL;
      }}
    >
      <div className="max-h-[670px] max-w-[464px] mx-auto sm:p-6 pt-2 bg-white rounded-lg flex flex-col gap-3 items-center justify-center">
        <Loading />
        <Typography variant="p" className="text-textPrimary mt-4">
          Redirecting to secure code sign-in...
        </Typography>
      </div>
    </CommonAuthLayout>
  );
};
